import Image from "components/ui/image";

import { useTranslation } from "react-i18next";

import BonusesInfo from "../../components/bonusesInfo";
import GradientButton from "components/ui/gradientButton/index.jsx";
import { buildPathToStaticFolderOfCDN } from "utils/common.js";

const FreeBetView = ({
	bonuses,
	isSingleType,
	isMobile,
	isTablet,
	handleOnOk,
	handleOnActivateBonuses,
	currencyCode,
	assignedGameTypes,
	disableBtnActivateBonuses = false,
	disableBtnActivateBonusesReason = null
}) => {
	const { t } = useTranslation();

	return (
		<>
			<div className="vs--bonus-modal-background">
				<Image
					className="vs--bonus-modal-img"
					src={buildPathToStaticFolderOfCDN(`images/banners/bonus.png`)}
					alt="bonus advertising video"
				/>
				
				<img className="vs--bonus-modal-background-text" src={buildPathToStaticFolderOfCDN(`images/banners/bonus-text.png`)} />
				
			</div>
			<BonusesInfo
				bonuses={bonuses}
				isSingleType={isSingleType}
				currencyCode={currencyCode}
				isMobile={isMobile}
				isTablet={isTablet}
				assignedGameTypes={assignedGameTypes}
			/>
			<div className="vs--bonus-modal-notification-footer">
				<GradientButton onClick={handleOnOk}>
					{t("common.okay")}
				</GradientButton>
				<GradientButton type='secondary' onClick={handleOnActivateBonuses} disabled={disableBtnActivateBonuses || disableBtnActivateBonusesReason}>
					{t("common.activateBonuses")}
				</GradientButton>
			</div>
		</>
	);
};
export default FreeBetView;
